import React from 'react';
import { useHistory } from 'react-router-dom';
import { LandingContent } from 'components/LandingContent';
import landingImage from 'assets/images/projects/index-projects2.jpg';

const PausedLanding = ({ isOrgOwner }) => {
  const history = useHistory();
  const goToBilling = () => {
    history.push('/app/v2/account/billing');
  };

  const landContent = () => {
    return (
      <>
        {isOrgOwner ? (
          <>
            Your account is currently on a 90-day pause, and your subscription will resume automatically
            once the pause duration is over. If you’d like to reactivate your account or cancel your subscription,
            please visit your subscriptions and billing page <a href='/app/v2/account/billing'><span>here</span></a>.
          </>

        ) : (
          <>
            It looks like your account isn’t currently linked to an organization or project in Aisle Planner.
            Not to worry, this is usually a quick fix!
            Reach out to the person who invited you into their account for assistance,
            but if that doesn’t do the trick, contact us at customer support{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://help.aisleplanner.com/en/articles/2126011-contact-us"
            >
              <span>here</span>
            </a>
            .
          </>
        )}
      </>
    );
  };

  return (
    <div className="content-container">
      <LandingContent
        action={goToBilling}
        title="Account Paused"
        description={landContent()}
        actionButtonTitle={isOrgOwner ? 'Re-Subscribe Today' : ''}
        heroImage={landingImage}
      />
    </div>
  );
};

export default PausedLanding;
